import { useQuery } from "@tanstack/react-query";
import { useStaffWorkspace } from "../../../app/session";
import { api } from "../../../data";
import { ladeAnfrage, ladeAnfragen, ladeAngebotsEinstellungen, ladePreisliste } from "./daten";

/** Abfragen der Anfragen. Schlüssel beginnen mit der Tabelle, damit das Neuladen nach Aktionen greift (useAction lädt alles neu). */

export function useAnfragen() {
  const ws = useStaffWorkspace();
  const orgId = ws.org.org_id;
  return useQuery({ queryKey: ["inquiries", orgId, "liste"], queryFn: () => ladeAnfragen(api, orgId) });
}

export function useAnfrage(id: string | undefined) {
  const ws = useStaffWorkspace();
  const orgId = ws.org.org_id;
  return useQuery({ queryKey: ["inquiries", orgId, "detail", id], enabled: !!id, queryFn: () => ladeAnfrage(api, orgId, id!) });
}

export function useAngebotsEinstellungen(orgId: string) {
  return useQuery({ queryKey: ["org_offer_settings", orgId], queryFn: () => ladeAngebotsEinstellungen(api, orgId) });
}

export function usePreisliste(talentId: string, enabled = true) {
  return useQuery({ queryKey: ["talent_rate_cards", talentId], enabled, queryFn: () => ladePreisliste(api, talentId) });
}

export function useKontakte(brandId: string) {
  return useQuery({
    queryKey: ["brand_contacts", brandId, "anfrage"],
    enabled: !!brandId && brandId !== "__neu",
    queryFn: () => api.select<{ id: string; brand_id: string; name: string; email: string | null }>("brand_contacts", {
      columns: "id, brand_id, name, email", filters: [["brand_id", "eq", brandId]], order: [["name", "asc"]],
    }),
  });
}
